export default "__VITE_ASSET__31b1617c__"